<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Listar Capacitações
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
      </div>
      <div class="col-md col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Status</div>
        <q-select
          v-model="dados.status"
          :options="options.optionsStatus"
          dense
          outlined
          class="select"
        />
      </div>
      <div class="col-md">
        <div class="q-ml-sm texto-titulo-input">Data de Criação</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="dados.dataCriacao"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.dataCriacao"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md">
        <div class="q-ml-sm texto-titulo-input">Data de Execução</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="dados.dataExecucao"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.dataExecucao"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Treinamento</div>
        <q-input
          v-model="dados.treinamento"
          dense
          outlined
          class="select"
          label="Digite o Treinamento"
        />
      </div>
      <div class="col-md col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Pessoa</div>

        <SelecaoSolicitante
          :label="'Pesquise a Pessoa'"
          @emitirFuncionario="receberFuncionario"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          label="Filtrar"
          icon="filter_alt"
          color="primary"
          no-caps
          @click="listarCapacitacoes()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Lista de Capacitações
        </span>
        <div
          class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="dados.descricao"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaCapacitacoes"
        :loading="loading"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        class="tabela-tamanho-fixo"
        dense
        hide-pagination
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.descricao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">#Treinamentos: </strong>
                    {{ props.row.quantidadeTreinamentos }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">#Pessoas: </strong>
                    {{ props.row.quantidadeFuncionarios }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Criação: </strong>
                    {{
                      props.row.dataCriacao
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Execução: </strong>
                    {{
                      props.row.dataRealizacao
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Status: </strong>
                    {{ props.row.status }}</span
                  >
                </div>
                <div class="col-3">
                  <div class="row col-12 justify-center">
                    <q-btn
                      color="blue-6"
                      round
                      size="md"
                      icon="add"
                      @click="detalharCapacitacao(props.row.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.descricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-treinamentos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quantidadeTreinamentos }}
          </q-td>
        </template>
        <template v-slot:body-cell-pessoas="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.quantidadeFuncionarios }}
          </q-td>
        </template>
        <template v-slot:body-cell-criacao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.dataCriacao
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-execucao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.dataRealizacao
                ?.split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.status }}
          </q-td>
        </template>
        <template v-slot:body-cell-detalhes="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'treinamento-detalhe-capacitacao',
                params: { capacitacaoId: props.row.id },
              }"
            >
              <q-btn color="blue-6" round size="sm" icon="add" />
            </router-link>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
const columns = [
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "treinamentos",
    label: "#Treinamentos",
    align: "left",
  },
  {
    name: "pessoas",
    label: "#Pessoas",
    align: "left",
  },
  {
    name: "criacao",
    label: "Criação",
    align: "left",
  },
  {
    name: "execucao",
    label: "Execução",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "detalhes",
    label: "Detalhes",
    align: "center",
  },
];
export default {
  components: { SelecaoSolicitante, ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const router = useRouter();

    const dados = ref({
      descricao: "",
      status: {
        label: "Todos",
        value: "",
      },
      dataCriacao: "",
      dataExecucao: "",
      treinamento: "",
      pessoas: "",
    });
    const options = {
      optionsStatus: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Finalizados",
          value: "finalizado",
        },
        {
          label: "Em Aberto",
          value: "aberto",
        },
      ],
    };
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const listaCapacitacoes = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);

    const listarCapacitacoes = async (page = 0, rowsNumber = 10) => {
      await unidade.value.id;
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch(
          "treinamento/listarCapacitacoes",
          {
            descricao: dados.value.descricao,
            per_page: rowsNumber,
            page: page,
            status: dados.value.status.value,
            unidadeId: unidade.value.id,
            data_criacao: dados.value.dataCriacao
              .split("/")
              .reverse()
              .join("/"),
            data_execucao: dados.value.dataExecucao
              .split("/")
              .reverse()
              .join("/"),
            pessoas: dados.value?.pessoas?.name,
            treinamento: dados.value.treinamento,
          }
        );
        listaCapacitacoes.value = response.data.data;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.page = response.data.current_page;
        pagination.value.rowsNumber = response.data.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const detalharCapacitacao = (id) => {
      router.push({
        name: "treinamento-detalhe-capacitacao",
        params: { capacitacaoId: id },
      });
    };

    const receberFuncionario = (value) => {
      dados.value.pessoas = value;
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarCapacitacoes();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarCapacitacoes(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => dados.value.descricao,
      () => {
        listarCapacitacoes();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarCapacitacoes);

    return {
      columns,
      unidade,
      dados,
      options,
      listarCapacitacoes,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      listaCapacitacoes,
      detalharCapacitacao,
      receberFuncionario,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .select {
    font-size: 12px;
  }
  .btn {
    margin: 1px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
